import React from "react";
import {PageContainer} from "../../../library/components/old/page-container";

export function ExplorePage(props) {
    return <PageContainer>

    </PageContainer>
}